<!-- Path: libs/core/shell/src/lib/layout/public/hero/hero-header/hero-header.component.html -->
<section class="hero-header">
  <div class="hero-header__stage">
    <div
      class="hero-header__banner"
      [class.hero-header__banner--fallback]="!hasPromos()"
      style="background-size: contain; background-repeat: no-repeat;"
      [style.background-image]='"url(assets/banner.png)"'
    >
      <div class="hero-header__banner-layer"></div>

      @if (hasPromos()) {
        <div class="hero-header__promos-wrap">
          <div
            class="hero-header__promos"
            [class.hero-header__promos--one]="promoCount() === 1"
            [class.hero-header__promos--two]="promoCount() === 2"
            [class.hero-header__promos--three]="promoCount() === 3"
            #carousel
            (scroll)="onCarouselScroll($event)"
          >
            <!-- @for (promo of visiblePromos(); track promo.id) {
              <div class="hero-header__slide">
                <lib-hero-card
                  [badge]="promo.badge ?? 'Oferta especial'"
                  [title]="promo.title"
                  [description]="promo.description ?? null"
                  [price]="promo.price ?? null"
                  [compareAtPrice]="promo.compareAtPrice ?? null"
                  [ctaLabel]="promo.ctaLabel ?? 'Ver oferta'"
                  [imageUrl]="promo.imageUrl ?? null"
                  [imageAlt]="promo.imageAlt ?? promo.title"
                  (cardPressed)="selectPromo(promo)"
                  (actionPressed)="selectPromo(promo)"
                ></lib-hero-card>
              </div>
            } -->
          </div>

          @if (promoCount() > 1) {
            <div class="hero-header__dots" aria-hidden="true">
              @for (promo of visiblePromos(); track promo.id; let i = $index) {
                <button
                  class="hero-header__dot"
                  [class.hero-header__dot--active]="activeSlide() === i"
                  type="button"
                  (click)="goToSlide(i)"
                ></button>
              }
            </div>
          }
        </div>
      }
    </div>

    <div class="hero-header__dock">
      <a
        class="hero-header__brand"
        href=""
        aria-label="Ir para o início"
        (click)="goHome($event)"
      >
        <span class="hero-header__brand-frame">
          @if (resolvedBrandImage()) {
            <img
              class="hero-header__brand-image"
              [src]="resolvedBrandImage()"
              [alt]="cfg.appName"
              width="100%"
              height="100%"
            />
          } @else {
            <span class="hero-header__brand-fallback" aria-hidden="true"></span>
          }
        </span>
      </a>

      <form class="hero-header__search" (submit)="onSearchSubmit($event)">
        <span class="hero-header__search-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M10.9 18.2a7.3 7.3 0 1 1 0-14.6 7.3 7.3 0 0 1 0 14.6Z"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
            />
            <path
              d="m16.4 16.4 4.2 4.2"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
            />
          </svg>
        </span>

        <input
          class="hero-header__search-input"
          type="search"
          name="search"
          [disabled]="!isOpen()"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchInput($event)"
          [placeholder]="searchPlaceholder()"
          aria-label="Buscar produtos"
          autocomplete="off"
        />
        
    @if (isOpen()) {
      <div class="hero-header__status" role="status" aria-label="Estabelecimento aberto">
        <span class="hero-header__status-dot" aria-hidden="true"></span>
        <span class="hero-header__status-label">Aberto</span>
      </div>
    } 
        

      </form>

      <div class="hero-header__actions">
        <button
          class="hero-header__icon-btn"
          type="button"
          aria-label="Abrir carrinho"
          (click)="openCart()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M6.6 6h14.1l-1.7 8.3a2 2 0 0 1-2 1.6H9a2 2 0 0 1-2-1.6L5.1 3.8A1.5 1.5 0 0 0 3.6 2.6H2.5"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.2 21a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4ZM17.3 21a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z"
              fill="currentColor"
            />
          </svg>

          @if (cartCount() > 0) {
            <span class="hero-header__badge">{{ cartCount() }}</span>
          }
        </button>

        <button
          class="hero-header__icon-btn"
          type="button"
          aria-label="Alternar tema"
          (click)="toggleTheme()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M12 18.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
            />
            <path
              d="M12 2v2.3M12 19.7V22M22 12h-2.3M4.3 12H2M19.1 4.9l-1.6 1.6M6.5 17.5 4.9 19.1M19.1 19.1l-1.6-1.6M6.5 6.5 4.9 4.9"
              fill="none"
              stroke="currentColor"
              stroke-width="1.4"
              stroke-linecap="round"
            />
          </svg>
        </button>

<button
  class="hero-header__icon-btn"
  type="button"
  aria-label="Perfil do usuário"
  (click)="goToProfile()"
>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M12 12.2a3.7 3.7 0 1 0 0-7.4 3.7 3.7 0 0 0 0 7.4Z"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
            />
            <path
              d="M5.3 20a7.6 7.6 0 0 1 13.4 0"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            />
            <circle
              cx="12"
              cy="12"
              r="9"
              fill="none"
              stroke="currentColor"
              stroke-width="1.4"
            />
          </svg>
        </button>
      </div>
    </div>

  </div>
</section>

<lib-modal-global
[hasFloatingContent]="true"
  [open]="authModalOpen()"
  [title]="authClientState().title"
  [description]="authClientState().description"
  [size]="'md'"

  [closeOnBackdrop]="false"
  [closeOnEscape]="false"
  [showCloseButton]="true"
  [showFooter]="true"
  [buttons]="authModalButtons()"
  (buttonPressed)="onAuthModalButtonPressed($event)"
  (closed)="closeAuthModal()"
>
<lib-ui-mascot

  modal-floating
  [imageSrc]="authMascotState().imageSrc"
  [imageAlt]="authMascotState().imageAlt"
  [images]="authMascotState().images ?? []"
  [imageIndex]="authMascotState().imageIndex ?? 0"
  [eyes]="authMascotState().eyes ?? 'default'"
  [size]="authMascotState().size ?? 'md'"
  [animation]="authMascotState().animation ?? 'idle'"
  [thoughtEmoji]="authMascotState().thoughtEmoji ?? null"
  [thoughtText]="authMascotState().thoughtText ?? null"
  [thoughtVisible]="authMascotState().thoughtVisible ?? false"
></lib-ui-mascot>
  @if (authModalOpen()) {
    <lib-auth-client
      [lookupOnPhoneBlur]="true"
      (stateChanged)="onAuthClientStateChanged($event)"
      (authenticated)="onClientAuthenticated($event)"
    ></lib-auth-client>
  }
</lib-modal-global>
